import { Box, Paper, Typography, useTheme } from "@mui/material"
import { ChatViewer } from "../interfaces"
import { format } from "date-fns"
import { ru } from "date-fns/locale"

interface MessageProps {
  message: ChatViewer.Message
}

export const Message: React.FC<MessageProps> = ({ message }) => {
  const theme = useTheme()
  const isUser = message.role === "user"
  const isManager = message.role === "manager"

  // Определяем метку роли
  const roleLabel = isUser ? "Пользователь" : isManager ? "Менеджер" : "Система"

  // Определяем стили в зависимости от роли
  const messageStyles = isUser
    ? {
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.grey[800]
            : theme.palette.grey[200],
        color: theme.palette.text.primary,
        alignSelf: "flex-start" as const,
        borderBottomLeftRadius: 4,
      }
    : isManager
      ? {
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.success.dark
              : theme.palette.success.light,
          color:
            theme.palette.mode === "dark"
              ? theme.palette.text.primary
              : theme.palette.text.primary,
          alignSelf: "flex-end" as const,
          borderBottomRightRadius: 4,
        }
      : {
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.secondary.dark
              : theme.palette.secondary.light,
          color:
            theme.palette.mode === "dark"
              ? theme.palette.text.primary
              : theme.palette.text.primary,
          alignSelf: "flex-end" as const,
          borderBottomRightRadius: 4,
        }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: isUser ? "flex-start" : "flex-end",
        mb: 2,
        maxWidth: "70%",
        alignSelf: messageStyles.alignSelf,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          opacity: 0.7,
          mb: 0.5,
          px: 2,
          color: theme.palette.text.secondary,
        }}
      >
        {roleLabel}
      </Typography>
      <Paper
        elevation={1}
        sx={{
          px: 2,
          py: 1.5,
          borderRadius: 2.25,
          ...messageStyles,
          wordWrap: "break-word",
          whiteSpace: "pre-wrap",
          maxWidth: "100%",
        }}
      >
        <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
          {message.message}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mt: 0.5,
            opacity: 0.7,
            fontSize: "0.7rem",
          }}
        >
          {format(new Date(message.created_at), "dd.MM.yyyy HH:mm", {
            locale: ru,
          })}
        </Typography>
      </Paper>
    </Box>
  )
}
